import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TextAreaComponent } from '../components/text-area.component';


@NgModule({
  declarations: [
    TextAreaComponent,
    
  ],
  imports:[
    CommonModule,
    FormsModule 

  ],
  exports:[
    TextAreaComponent
  ]
})
export class TextAreaModule { }
